const sectionsToRender = [
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body',
  },
  {
    id: '#CartDrawer-Head',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Head',
  },
  {
    id: '#CartDrawer-Summary',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Summary',
  },
  {
    id: '#Cart-Drawer-Widget-Cross-Sell-Head',
    section: 'cart-drawer',
    selector:
      '#shopify-section-cart-drawer #Cart-Drawer-Widget-Cross-Sell-Head',
  },
  {
    id: '#Cart-Drawer-Widget-Recommendations-Head',
    section: 'cart-drawer',
    selector:
      '#shopify-section-cart-drawer #Cart-Drawer-Widget-Recommendations-Head',
  },
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close(),
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this),
    );
    this.setListeners();
    this.setCartLinks();
  }

  connectedCallback() {
    this.fetchRecommendations();
  }

  setListeners() {
    this.querySelectorAll('[data-button-widget]').forEach((button) => {
      button.addEventListener('click', (event) => {
        const widget = this.querySelector(
          `[data-widget="${event.target.dataset.buttonWidget}"]`,
        );

        this.toggleWidget(widget);
      });
    });
  }

  setCartLinks() {
    const cartLinks = document.querySelectorAll('[data-cart-link]');

    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() !== 'SPACE') return;
        event.preventDefault();
        this.open(cartLink);
      });
    });
  }

  async fetchRecommendations() {
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cartJson = await cartResponse.json();
    const recommendations = this.querySelector(
      '[data-widget="recommendations"]',
    );

    if (!recommendations || !cartJson.items[0]) {
      return;
    }

    fetch(
      `${recommendations.dataset.url}&product_id=${cartJson.items[0].product_id}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const items = html.querySelector('[data-widget-list]');

        if (!items) {
          return;
        }

        recommendations.querySelector('[data-widget-list]').innerHTML =
          items.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  fetchUpsells(html) {
    const widget = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('[data-widget="cross-sell"]');

    if (!widget) {
      return;
    }

    const widgetItems = widget.querySelector('[data-items]');

    this.querySelector('[data-widget="cross-sell"] [data-items]').innerHTML =
      widgetItems.innerHTML;
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true },
    );
    bodyScroll.lock(this.querySelector('#CartDrawer-Body'));
  }

  close() {
    this.closeWidgets();
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);
    bodyScroll.clear();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.querySelector('#CartDrawer');
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) {
        return;
      }
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector,
      );
    });
    this.open();
    this.setListeners();
    this.fetchRecommendations();
    this.closeWidgets();
    this.fetchUpsells(response.sections['cart-drawer']);
  }

  getSectionsToRender() {
    return [...Cart.getLiveRegions(), ...sectionsToRender];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  closeWidgets() {
    const widgets = this.querySelectorAll('[data-widget]');

    widgets.forEach((widget) => {
      this.toggleWidget(widget, true);
    });
  }

  toggleWidget(widget, close) {
    const widgets = this.querySelectorAll('[data-widget]');

    if (!widget) {
      return;
    }

    if (close) {
      widget.classList.remove('is-visible');

      return;
    }

    widget.classList.toggle('is-visible');
    widgets.forEach((el) => {
      if (el === widget) {
        return;
      }

      el.classList.remove('is-visible');
    });

    if (widget.classList.contains('is-visible')) {
      bodyScroll.lock(widget.querySelector('[data-widget-overflow]'));
    } else {
      bodyScroll.lock(this.querySelector('#CartDrawer-Body'));
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();

    this.cartDrawer = this.closest('cart-drawer');
  }

  getSectionsToRender() {
    return [...Cart.getLiveRegions(), ...sectionsToRender];
  }

  updateLiveRegions(parsedState) {
    super.updateLiveRegions(parsedState);
    this.cartDrawer.setListeners();
    this.cartDrawer.fetchRecommendations();
    this.cartDrawer.closeWidgets();
    this.cartDrawer.fetchUpsells(parsedState.sections['cart-drawer']);
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
